// @mui
import { styled, useTheme } from '@mui/material/styles';
import { Button, Container, Typography, Box, Alert } from '@mui/material';
import { SiGoogle } from "react-icons/si";
import { useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import Page from '../components/Page';
import { useAuth } from '../contexts/AuthContext';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
    paddingTop: theme.spacing(10),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: theme.palette.mode === 'dark' ? '#121212' : '#f4f6f8',
}));

const ContentStyle = styled(Container)(({ theme }) => ({
    textAlign: 'center',
    background: theme.palette.mode === 'dark' ? '#1E1E1E' : '#fff',
    padding: theme.spacing(5),
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[3],
    maxWidth: '600px',
}));

export default function About() {
    const theme = useTheme();
    const { loginWithGoogle } = useAuth();
    const navigate = useNavigate();
    const [error, setError] = useState(null)

    const handleGoogleLogin = async () => {
        try {
            await loginWithGoogle();
            navigate("/dashboard");
        } catch (error) {
            setError(error.message)

        }
    };

    return (
        <Page title="ITM Ad Server">
            <RootStyle>
                <ContentStyle>
                    <Typography variant="h2" sx={{ fontWeight: 'bold', mb: 2 }}>
                        ITM Ad Server
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
                        Ad Server for managing Emails, Native Ads, and Listicles.
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: 'medium', mb: 3 }}>
                        Login with your <span style={{ color: theme.palette.primary.main }}>@itstoday.org</span> email
                    </Typography>

                    {/* Show error if unauthorized domain */}
                    {error != null && (
                        <Alert severity="error" sx={{ mb: 3 }}>
                            ❌ {error}.
                        </Alert>
                    )}

                    {/* Centered Login Button */}
                    <Box display="flex" justifyContent="center">
                        <Button
                            variant="contained"
                            color="success"
                            startIcon={<SiGoogle />}
                            onClick={handleGoogleLogin}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 1,
                                padding: '12px 24px',
                                fontSize: '16px',
                                borderRadius: '8px',
                                boxShadow: theme.shadows[2],
                                transition: 'all 0.3s',
                                '&:hover': {
                                    backgroundColor: theme.palette.success.dark,
                                    boxShadow: theme.shadows[4],
                                },
                            }}
                        >
                            Sign in with Google
                        </Button>
                    </Box>
                </ContentStyle>
            </RootStyle>
        </Page>
    );
}